import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import moment from 'moment';
import { CustomerImpactEditEventDto } from 'generated/request-backend';

export default function CustomerImpactEditHistory({ edit }: { edit?: CustomerImpactEditEventDto }) {
    const { t } = useTranslation();
    if (!edit) return null;
    return (
        <section aria-label={t('Customer impact edit history')}>
            <div>
                <Trans>Edited by</Trans>: {edit.editedBy?.displayName || '--'}{' '}
                {t('{{date}} at {{time}}', {
                    date: moment(edit.editedOn).format('MMM DD YYYY'),
                    time: moment(edit.editedOn).format('hh:mm a'),
                })}
            </div>
            <div><Trans>Previous customer impact description</Trans></div>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(edit.oldDescription || '') }} />
            <div><Trans>Updated customer impact description</Trans></div>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(edit.newDescription || '') }} />
            <div>
                <Trans>Revenue impacted</Trans>: {edit.originalImpact?.revenue ?? '--'}{' -> '}{edit.updatedImpact?.revenue ?? '--'}
            </div>
            <div>
                <Trans>Devices impacted</Trans>: {edit.originalImpact?.deviceCount ?? '--'}{' -> '}{edit.updatedImpact?.deviceCount ?? '--'}
            </div>
        </section>
    );
}
